// /client/src/components/ExternalInternalContext.js
import React from 'react';
import NavigationPdfs from './NavigationPdfs';
import FooterPdfs from './FooterPdfs';

const ExternalInternalContext = () => {
  return (
    <>
      <div className="fullHeight is-flex is-flex-direction-column is-align-items-center is-justify-content-space-between">
        <div className='fullWidth'>
            <NavigationPdfs />
            <div className="pt-2 columns is-centered">
                <div className="column is-6-tablet is-5-desktop is-5-widescreen">
                    <div className="px-4 py-5">
                        <h1 className="h1 colorBlack is-bold">Notice Your External and Internal Context</h1>
                        <h2 className='h2 is-bold'>Introduction</h2>
                        <p className="pb-4 colorBlack">
                            When you take a physical step, you need to know where you are in time and space. Your brain rapidly assesses where your body is and what the terrain looks like so that you can navigate your environment. As you prepare to step, you do it differently depending on whether the walkway is icy, there are uneven stones, or if the path is smooth. These details inform your action. According to Merriam-Webster, context is the circumstances in which something exists or occurs.
                        </p>
                        <div className="py-5 field">
                            <a 
                                href="/pdfs/next-move-notice-your-external-and-internal-context.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="button"
                                download
                            >
                                Download PDF
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       <FooterPdfs />
      </div>
    </>
  );
};

export default ExternalInternalContext;